import { CryptoKeyUsage, IWebCryptoAlgSettings } from "../../../Global/Base/Security/SecurityUtils";

export interface IWebCryptoProviderSettings {
    /**
     * Název algoritmu dle specifikace JWK.
     * http://www.w3.org/TR/WebCryptoAPI/#jwk-mapping-alg
     * https://tools.ietf.org/html/rfc7518#appendix-A.2
     */
    algorithmName: string;

    /**
     * KeyType (kty) dle specifikace JWK
     */
    keyType: string;

    /**
     * Vrací nastavení algoritmu pro import jwk klíče.
     */

    /**
     * Operace, ktere multiweb umoznuje provest pomoci tohoto provideru
     */
    allowedUsage: CryptoKeyUsage[];

    /**
     * Nastavení JWK klíče
     */
    webCryptoAlgSettings: IWebCryptoAlgSettings;

    /**
     * Zakóduje data do UTF8 a zašifruje zadaným klíčem
     * @param bytes data pro zašifrování
     * @param key šifrovací klíč
     */
    encryptBuffer(buffer: ArrayBuffer, jwk: JsonWebKey): Promise<ArrayBuffer>;
}
